import { getOrdinalSuffix } from 'utils';
import { getDebounce } from 'utils';
import { getIsMobile } from 'utils';

let debounce = getDebounce();

const isMobile = getIsMobile();

let selectedUnit;
let baseColor;
let selectedUnitColor;
let lastTouchDistance;

const removeUnitColor = () => {
  selectedUnit?.color(selectedUnitColor);
  document.removeEventListener('mousedown', removeUnitColor)
}

export default {
  refreshOn: ({ mapId }) => [mapId],
  init: async ({ containerRef, mapId }, outlet, internalStateSetter) => {
    if (!mapId) {
      outlet({ map: null });
      return;
    }

    const mapp = unitmap(containerRef.current, 'v1j68BjJTlbpocBB4wtf1BBujgBELbTC', {});
    containerRef.current.innerHTML = null;
    mapp.load(mapId);

    mapp.on('ready', async (event) => {
      let selection = mapp?.levels().has({ floor: true });
      let floors;
      const selectionData = selection ? selection.data() : [];

      if (Array.isArray(selectionData)) {
        floors = Array.from(
          new Set(selectionData.map((s) => s?.tags?.floor))
        );
      } else {
        floors = [selectionData?.tags?.floor];
      }

      let f_floors = [];

      let uniqueFloors = [...new Set(floors)];

      uniqueFloors.forEach((floor, i) => {
        if (i <= 20) {
          f_floors.push({
            id: `${i} Floor`,
            display: i === 0 ? `Ground Floor` : `${getOrdinalSuffix(i)} Floor`,
            code: parseInt(floor)
          });
        }
      });

      mapp.on('unit:mouseenter', (event) => {
        baseColor = event.unit.data().fill;
        if (event?.unit?.id !== selectedUnit?.id) event.unit.color('#6bbabf');
      });

      mapp.on('unit:mouseout', (event) => {
        if (event.unit.id !== selectedUnit?.id) event.unit.color(baseColor);
      });

      mapp.on('unit:click', (event) => {
        if (selectedUnit?.id === event?.unit?.id) {
          selectedUnit = null;
          return;
        }
        selectedUnitColor = baseColor;
        event.unit.color('#04333B');
        selectedUnit = event.unit;
        document.addEventListener('mousedown', removeUnitColor)
        if (isMobile) {
          let a = event.unit.center();
          mapp.panTo([a[0], a[1] - 200])
        }
        outlet({ selectedUnit, clickEvent: event.originalEvent });
      });

      mapp.maxScale(2);
      await mapp.autoScale();
      let minScale = parseFloat(mapp.scale()).toFixed(3);
      await internalStateSetter({ zoom: 100, map: mapp, floorsList: f_floors, selectedFloorId: f_floors[0]?.id });
      selection?.where({ floor: f_floors[0]?.code }).show();
      selection?.except({ floor: f_floors[0]?.code }).hide();

      const observer = new MutationObserver(async () => {
        if (mapp) {
          debounce(async () => {
            let mapScale = parseFloat(mapp.scale()).toFixed(3);
            if (mapScale < minScale) return;
            let newZoom = parseFloat((((mapScale - minScale) / (2 - minScale)) * 100) + 100).toFixed();
            await internalStateSetter({ zoom: newZoom });
          }, 100)
        }
      })

      var mapElement = document.getElementById("map");


      const handleTouchMove = (event) => {

        if (event.ctrlKey) {
          event.preventDefault();
          const scrollAmount = event.deltaY;

          mapp.zoom(-scrollAmount)
        }
      };

      if (mapElement) {
        mapElement.addEventListener('wheel', handleTouchMove);

        observer.observe(mapElement, {
          attributes: true,
          attributeFilter: ['transform']
        })
      }

      mapElement.parentNode.addEventListener('mousedown', function (event) {
        // Create a new mousedown event
        const newEvent = new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true,
          view: window
        });

        // Dispatch the event on the second element
        document.dispatchEvent(newEvent);
      }, true);

      outlet({ map: mapp });
    });
  },
  'UnitMap.Wrapper.MapZoom': ({ action, map, zoom }) => {
    if (action === 'ZoomIn') {
      map?.zoom(0.1)
    }
    if (action === 'ZoomOut' && zoom != 100) {
      map?.zoom(-0.1)
    }
    if (action === 'Reset') {
      map?.autoScale();
    }
  },
  'UnitMap.Wrapper.Dropdown': ({ selectedOptionId, options, map }, _, internalStateSetter) => {
    let floor = options.find(o => o.id == selectedOptionId);
    internalStateSetter({ selectedFloorId: floor.id });
    let selection = map?.levels().has({ floor: true });
    selection?.where({ floor: floor.code }).show();
    selection?.except({ floor: floor.code }).hide();
  },
  'UnitMap.Wrapper.Reset': ({ map }) => {
    map?.autoScale();
  }
};
